export default __webpack_public_path__ + "/assets/mega_02.jpg";